import { API, graphqlOperation } from "aws-amplify";
import { updateProject } from "../../graphql/mutations";
import { validator } from "./inputFieldValidation.js";

const cleanParticipant = (participant) => ({
  email: typeof participant.email === "string" ? participant.email.trim() : participant.email,
  firstName: typeof participant.firstName === "string" ? participant.firstName.trim() : participant.firstName,
  lastName: typeof participant.lastName === "string" ? participant.lastName.trim() : participant.lastName,
  title: typeof participant.title === "string" ? participant.title.trim() : (participant.title || ""),
});

const UpdateProjectName = async (project, projectName) => {
  const projectNameValidation = validator.validate({ inputString: projectName });
  if (!(projectNameValidation.error === undefined)) {
    throw new Error("Bad request");
  }

  try {
    const input = {
      id: project.id,
      projectName: projectName,
      participants: (project.participants || []).map(cleanParticipant)
    };

    const updatedProject = await API.graphql(
      graphqlOperation(updateProject, input)
    );
    return updatedProject;
  } catch (error) {
    throw new Error("InternalServerError");
  }
};

export default UpdateProjectName;
